import React, { useEffect, useReducer, useState, useRef, useMemo } from "react"
import {
  get,
  map,
  clone,
  merge,
  concat,
  find,
  split,
  reject,
  take,
  times,
  compact,
  isEmpty,
  includes,
  head,
  tail,
  zipObject,
  forEach,
  groupBy,
  pick,
  initial,
  isNull,
  isNil,
} from "lodash"
import ClassNames from "classnames"
import uuid from "uuid"
import { Modal } from "react-bootstrap"
import { GetTicketKey } from "node-dist/nodeDistFlag"
import PushSymbol from "components/molecules/pushSymbol"
import {
  ATTENTION_WORDS,
  DETAIL_SEARCH_CONDITIONS,
  EQUITY_SECURITY_LIST,
  REGISTER_EXTENSION,
  REGISTER_EXTENSION_TYPE,
  SECURITY_TYPE,
  FOREIGN_STOCK,
  HEAT_MAP_LEVEL_UP,
  HEAT_MAP_LEVEL_DOWN,
} from "config/const"
import { createColumns, judgeHeatMapColor } from "config/table_columns"
import { Panel } from "./index"
import { MultipleLineTable, SeparateTable } from "components/molecules/table"
import { AttentionWord } from "components/atoms/text/attention"
import { RegisterPropsType } from "components/pages/main/register"
import store from "redux/store"
import {
  initRegisterLoad,
  changeRegisterSheet,
  changeRegisterSheetName,
  editRegisterSymbolSheet,
  removeRegisterSymbolSheet,
  SymbolSheetType,
} from "redux/ducks/RegisterSymbol"
import * as Formatter from "utils/Formatter"
import { APIResponse } from "redux/apis/types"
import { calcContractPrice, calcEvaluateProfit } from "utils/calc"
import { BaseSelect } from "components/atoms/input/select"
import { SearchDetail } from "components/utils/search"
import { ToolTip } from "components/atoms/text/tooltip"
import { ChartInputNumeric } from "components/atoms/chart/parts/ChartInputNumeric"
import { setToastData } from "redux/ducks/Toast"
import { Btn } from "components/atoms/btn"
import { checkIsSp, checkIsBrowser } from "utils/util"
import { requestSymbol } from "redux/ducks/SymbolDetail"
import APIs from "redux/apis"
import { outputCSV } from "utils/csv"
import dayjs from "dayjs"
import { pageLoadRegist } from "../../../redux/ducks/PageLoad"
import { useSelector } from "react-redux"
import { LoadingType } from "redux/ducks/AutoLoadingFlag"

type FindExtension = (d: APIResponse.Res) => REGISTER_EXTENSION_TYPE
const findExtension = (d: APIResponse.Res) =>
  find(REGISTER_EXTENSION, {
    SecurityType: get(d, "SecurityType"),
    Exchange: get(d, "Exchange"),
  })

const changeRegisterSymbol = (extensions: string) => {
  const extensionList = reject(split(extensions, "\n"), d => !d)
  return extensionList.map(ex => {
    const extensionWord = ex.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )
    const splitExtension = split(extensionWord, ".")
    if (splitExtension.length !== 2) return null
    const findSymbol = find(REGISTER_EXTENSION, {
      extension: splitExtension[1],
    })
    if (!findSymbol) {
      return null
    } else {
      return {
        Symbol: splitExtension[0],
        SecurityType: findSymbol.SecurityType,
        Exchange: findSymbol.Exchange,
      }
    }
  })
}
const changeRegisterExtension = (data: Array<APIResponse.Res>) => {
  const list = map(data, d => {
    const extensionList = findExtension(d)
    return `${Formatter.symbol(d, "")}.${get(extensionList, "extension")}`
  })
  return list.join("\n")
}

const setTableData = async (data: Array<object>, setData: Function) => {
  const _tableData = map(data, (data: object, i: number) => {
    return merge(data, { id: i })
  })
  setData(_tableData)
}

const LumpRegisterModal: React.FC<{ data: SymbolSheetType }> = props => {
  const [isOpen, changeDisplay] = useState<boolean>(false)
  const [extensionArea, showExtensionArea] = useState(false)
  const [displayList, changeDisplayList] = useState(
    changeRegisterExtension(props.data.SymbolList)
  )
  const currentBrowser = checkIsBrowser()

  useEffect(() => {
    changeDisplayList(changeRegisterExtension(props.data.SymbolList))
  }, [props.data.SymbolList])

  useEffect(() => {
    if (!isOpen)
      changeDisplayList(changeRegisterExtension(props.data.SymbolList))
    showExtensionArea(false)
  }, [isOpen])

  const execute = () => {
    const registerList = changeRegisterSymbol(displayList)
    if (registerList.indexOf(null) >= 0) {
      store.dispatch(
        setToastData({
          bodyMessage: "銘柄コードに誤りがあります。",
        })
      )
      return
    } else {
      const symbolList = clone(props.data)
      symbolList.SymbolList = map(take(registerList, 50), (list, i) => {
        if (symbolList.SymbolList.length - 1 < i) {
          //新規入力時は、Symbol,SecurityType,Exchangeのみ返す
          return list
        } else if (
          //登録済みの銘柄の場合はSymbolSheetのデータを返す
          list.Symbol ===
            get(
              symbolList.SymbolList[i],
              list.SecurityType === SECURITY_TYPE.Equity.id
                ? "Symbol"
                : "Ticker"
            ) &&
          list.SecurityType === get(symbolList.SymbolList[i], "SecurityType") &&
          list.Exchange === get(symbolList.SymbolList[i], "Exchange")
        ) {
          return symbolList.SymbolList[i]
        } else {
          //登録済みの銘柄の市場を変更をしたりなどした場合は新規入力同様、Symbol,SecurityType,Exchangeのみ返す
          return list
        }
      })
      store.dispatch(editRegisterSymbolSheet(symbolList))
      changeDisplay(false)
    }
  }
  return (
    <>
      <div
        className="btn btn-primary btn-shaped"
        onClick={() => changeDisplay(true)}
      >
        一括登録
      </div>
      <Modal show={isOpen} onHide={() => changeDisplay(false)} size="lg">
        <Modal.Header>
          <div className="modal-header">
            <div className="header-title">一括登録</div>
            <div className="header-nav-icon-col">
              <div
                className="header-icon ripple"
                data-izimodal-close
                onClick={() => changeDisplay(false)}
              >
                <i className="material-icons">close</i>
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Panel title="" className="lump-register-modal">
            <div className="contents-block">
              <div className="message-col">
                <span>最大50行まで登録可能です。</span>
                <AttentionWord list={ATTENTION_WORDS.register} />
              </div>
            </div>
            <div className="symmetry-layout">
              <div
                className={ClassNames("contents-block", {
                  "extension-open": extensionArea && currentBrowser === "ie",
                })}
              >
                <div
                  className={ClassNames("text-field text-field-outlined", {
                    "extension-open": extensionArea,
                  })}
                >
                  <textarea
                    name={ClassNames("extensions", {
                      "extension-open": extensionArea,
                    })}
                    rows={25}
                    cols={10}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                      changeDisplayList(e.target.value)
                    }
                    value={displayList}
                    spellCheck={false}
                  />
                </div>
              </div>
              <div
                className={ClassNames("contents-block", {
                  "extension-open": extensionArea && currentBrowser === "ie",
                })}
              >
                <div
                  className="extension-area"
                  onClick={() => {
                    if (extensionArea) {
                      showExtensionArea(false)
                    } else {
                      showExtensionArea(true)
                    }
                  }}
                >
                  <Btn name="指定可能な市場拡張子" />
                  <i className="material-icons arrow-icon">
                    {extensionArea
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </div>
                {extensionArea && (
                  <ul>
                    {REGISTER_EXTENSION.map((li, i) => (
                      <li key={i}>{`${li.extension}: ${li.name}`}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div
              className="btn btn-primary btn-shaped"
              onClick={() => execute()}
            >
              一括登録
            </div>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-bottom-btn-row">
            <div
              className="btn btn-outline ripple"
              onClick={() => changeDisplay(false)}
            >
              閉じる
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const DeleteColumn: React.FC<{
  fn: Function
  show: boolean
  setShow: Function
}> = props => {
  const refs = useRef<HTMLElement>(null)
  const [position, setPosition] = useState<[number, number]>([null, null])
  const message = props.show ? "選択した銘柄を削除します。" : ""
  useEffect(() => {
    if (!!refs) {
      const clientRect = refs.current.getBoundingClientRect()
      const refsWidth = clientRect.left - clientRect.width / 2
      const windowWidth = window.innerWidth - message.length * 14
      setPosition([
        clientRect.top + clientRect.height,
        refsWidth > windowWidth ? windowWidth : refsWidth,
      ])
    }
  }, [refs, props.show])
  const agree = () => {
    props.fn()
    props.setShow(false)
  }

  return (
    <>
      <i
        className="material-icons"
        ref={refs}
        onClick={() => props.setShow(true)}
      >
        close
      </i>
      <ToolTip position={position} name={props.show ? message : null}>
        <div className="tooltip-body">
          <span className="erase" onClick={() => agree()}>
            【削除】
          </span>
          <span className="cancel" onClick={() => props.setShow(false)}>
            【キャンセル】
          </span>
        </div>
      </ToolTip>
    </>
  )
}

export const FourHalfValue: React.FC<RegisterPropsType> = props => {
  const [currentPosition, changePosition] = useState<any>({
    pos: 0,
    col: "left",
  })
  const autoLoadingFlag = useSelector(
    (state: { AutoLoadingFlag: LoadingType }) =>
      state.AutoLoadingFlag.autoLoading
  )
  const tableList = [
    createColumns("銘柄名", "symbol-name-cell", (data: object) => (
      <PushSymbol
        apiSymbol={data}
        ticketKey={GetTicketKey(data)}
        renderer={(push: any) => {
          const securityType = get(data, "SecurityType")
          const exchange = get(data, "Exchange")
          const heatMapColor = judgeHeatMapColor(
            autoLoadingFlag
              ? get(push, "ChangedRatio")
              : get(data, "ChangedRatio")
          )
          return (
            <div className={ClassNames("cell-group", heatMapColor)}>
              <div className="code-market-group">
                <span className="code-cell ellipsis-text">
                  {Formatter.symbol(data)}
                </span>
                <span className="market-cell ellipsis-text">
                  {securityType === SECURITY_TYPE.Equity.id
                    ? Formatter.divisionName(data, true)
                    : get(
                        find(REGISTER_EXTENSION, { Exchange: exchange }),
                        "extension"
                      )}
                </span>
              </div>
              <span className="ellipsis-text">
                {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
              </span>
            </div>
          )
        }}
      />
    )),
    createColumns("現在値", "currency-price-cell", (data: object) => (
      <PushSymbol
        apiSymbol={data}
        ticketKey={GetTicketKey(data)}
        renderer={(push: any, apiSymbol: any) => {
          const heatMapColor = judgeHeatMapColor(
            autoLoadingFlag
              ? get(push, "ChangedRatio")
              : get(apiSymbol, "ChangedRatio")
          )
          const Price = !isEmpty(push)
            ? get(push, "Price")
            : get(apiSymbol, "Price")
          const PriceTime = !isEmpty(push)
            ? get(push, "PriceTime")
            : get(apiSymbol, "PriceTime")
          return (
            <div className={ClassNames("cell-group", heatMapColor)}>
              <div className="currency-price-value liquid-item">
                {Formatter.number(
                  autoLoadingFlag ? Price : get(apiSymbol, "Price", null),
                  get(data, "NumberOfDecimals", 0)
                )}
              </div>
              <div className="time-col liquid-item">
                {Formatter.date(
                  autoLoadingFlag ? PriceTime : get(apiSymbol, "PriceTime"),
                  "HH:mm"
                )}
              </div>
            </div>
          )
        }}
      />
    )),
    createColumns("前日比", "changed-price-cell", (data: object) => (
      <PushSymbol
        apiSymbol={data}
        ticketKey={GetTicketKey(data)}
        renderIfChanged={{
          autoLoadingFlag,
        }}
        renderer={(push: any, apiSymbol: any, dataPush: any) => {
          const ChangedRatio = !isEmpty(push)
            ? get(push, "ChangedRatio")
            : get(apiSymbol, "ChangedRatio")
          const ChangedPrice = !isEmpty(push)
            ? get(push, "ChangedPrice")
            : get(apiSymbol, "ChangedPrice")
          const heatMapColor = judgeHeatMapColor(
            autoLoadingFlag
              ? ChangedRatio
              : get(apiSymbol, "ChangedRatio", null)
          )
          const element = autoLoadingFlag ? dataPush : null
          return (
            <div className={ClassNames("cell-group", heatMapColor)}>
              <div
                {...element}
                className={ClassNames(
                  "change-price-value",
                  Formatter.upDown(
                    autoLoadingFlag
                      ? ChangedPrice
                      : get(apiSymbol, "ChangedPrice", null)
                  )
                )}
              >
                {Formatter.number(
                  autoLoadingFlag
                    ? ChangedPrice
                    : get(apiSymbol, "ChangedPrice", null),
                  2,
                  "floor",
                  true
                )}
              </div>
              <div className="change-ratio-value liquid-item">
                (
                <span
                  className={ClassNames(
                    Formatter.upDown(
                      autoLoadingFlag
                        ? ChangedRatio
                        : get(apiSymbol, "ChangedRatio", null)
                    )
                  )}
                >
                  {Formatter.number(
                    autoLoadingFlag
                      ? ChangedRatio
                      : get(apiSymbol, "ChangedRatio", null),
                    2,
                    "floor",
                    true
                  )}
                </span>
                <span className="unit">%</span>)
              </div>
            </div>
          )
        }}
      />
    )),
  ]

  let leftData: Array<any> = props.registerSymbol.symbolSheet.SymbolList.slice(
    0,
    17
  )
  if (leftData.length < 17) {
    leftData = leftData.concat(
      times(17 - leftData.length, () => ({
        Symbol: null,
        Price: null,
        Changed: null,
        Bid: null,
        Ask: null,
        NumberOfDecimals: null,
      }))
    )
  }

  let centerData: any = props.registerSymbol.symbolSheet.SymbolList.slice(
    17,
    34
  )
  if (centerData.length < 17) {
    centerData = centerData.concat(
      times(17 - centerData.length, () => ({
        Symbol: null,
        Price: null,
        Changed: null,
        Bid: null,
        Ask: null,
        NumberOfDecimals: null,
      }))
    )
  }
  let rightData: any = props.registerSymbol.symbolSheet.SymbolList.slice(34, 50)
  if (rightData.length < 16) {
    rightData = rightData.concat(
      times(16 - rightData.length, () => ({
        Symbol: null,
        Price: null,
        Changed: null,
        Bid: null,
        Ask: null,
        NumberOfDecimals: null,
      }))
    )
  }
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    data => {
      return {
        id: data.SheetNo,
        name: data.SheetName,
      }
    }
  )

  return (
    <Panel
      title=""
      className="panel-four half"
      filter={
        <div className="control-row filter-control-row">
          <div className="filter-control-item">
            <div className="label-filter-control">表示リスト選択</div>
          </div>
          <div className="row-filter">
            <BaseSelect
              option={sheetList}
              value={props.registerSymbol.symbolSheet.SheetNo}
              onChange={(num: number) => {
                store.dispatch(changeRegisterSheet(String(num)))
              }}
            />
          </div>
        </div>
      }
    >
      <div className="table-component">
        <div className="registered-issues-edit-col">
          <SeparateTable
            list={tableList}
            data={leftData}
            active={currentPosition.col === "left" && currentPosition.pos}
            onClick={(data: object, i: number) => {
              props.setSymbol({
                type: "SET_SYMBOL_DETAIL",
                symbol: {
                  Symbol: get(data, "Symbol", null),
                  Exchange: get(data, "Exchange", null),
                  SecurityType: get(data, "SecurityType", null),
                },
              })
              changePosition({ pos: i, col: "left" })
            }}
          />
        </div>
        <div className="registered-issues-edit-col">
          <SeparateTable
            list={tableList}
            data={centerData}
            active={currentPosition.col === "center" && currentPosition.pos}
            onClick={(data: object, i: number) => {
              props.setSymbol({
                type: "SET_SYMBOL_DETAIL",
                symbol: {
                  Symbol: get(data, "Symbol", null),
                  Exchange: get(data, "Exchange", null),
                  SecurityType: get(data, "SecurityType", null),
                },
              })
              changePosition({ pos: i, col: "center" })
            }}
          />
        </div>
        <div className="registered-issues-edit-col">
          <SeparateTable
            list={tableList}
            active={currentPosition.col === "right" && currentPosition.pos}
            data={rightData}
            onClick={(data: object, i: number) => {
              props.setSymbol({
                type: "SET_SYMBOL_DETAIL",
                symbol: {
                  Symbol: get(data, "Symbol", null),
                  Exchange: get(data, "Exchange", null),
                  SecurityType: get(data, "SecurityType", null),
                },
              })
              changePosition({ pos: i, col: "right" })
            }}
          />
        </div>
      </div>
      <div className="message-row">
        <ul className="heat-map-level-list">
          {HEAT_MAP_LEVEL_UP.map((row, i) => (
            <li key={i} className={row.cls}>
              {row.msg}
            </li>
          ))}
        </ul>
        <ul className="heat-map-level-list">
          {HEAT_MAP_LEVEL_DOWN.map((row, i) => (
            <li key={i} className={row.cls}>
              {row.msg}
            </li>
          ))}
        </ul>
        <AttentionWord list={ATTENTION_WORDS.heatmap} />
      </div>
    </Panel>
  )
}

export const FourValue: React.FC<RegisterPropsType> = props => {
  const [currentPosition, changePosition] = useState<number>(0)
  const [showId, setShowId] = useState<number>(null)
  const [screenSize, setScreenSize] = useState(window.outerWidth)
  const [dropFlag, setDropFlag] = useState(false)
  const isSp = checkIsSp()
  const autoLoadingFlag = useSelector(
    (state: { AutoLoadingFlag: LoadingType }) =>
      state.AutoLoadingFlag.autoLoading
  )
  const isPushReceive = props.registerWindow && autoLoadingFlag

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenSize(window.innerWidth)
    })
  })

  useEffect(() => {
    setTableData(
      props.registerSymbol.symbolSheet.SymbolList,
      props.setTableData
    )
    setDropFlag(false)
  }, [props.registerSymbol.symbolSheet.SymbolList])

  useEffect(() => {
    if (dropFlag) {
      store.dispatch(
        editRegisterSymbolSheet({
          SheetNo: props.registerSymbol.symbolSheet.SheetNo,
          SheetName: props.registerSymbol.symbolSheet.SheetName,
          SymbolList: props.tableData,
        })
      )
    }
  }, [dropFlag])

  const tableList = compact([
    // props.registerWindow || isSp
    //   ? null
    //   : createColumns("", "sort-cell", () => (
    //       <i className="material-icons">drag_handle</i>
    //     )),
    createColumns("国", "country-cell", (data: object) => (
      <i
        className={`icon-solid icon-${get(
          find(EQUITY_SECURITY_LIST, {
            SecurityType: get(data, "SecurityType"),
          }),
          "icon"
        )}`}
      />
    )),
    createColumns("銘柄名", "symbol-name-cell", (data: object) => {
      const securityType = get(data, "SecurityType")
      const exchange = get(data, "Exchange")
      return (
        <div>
          <div className="code-market-group">
            <span className="code-cell ellipsis-text">
              {Formatter.symbol(data)}
            </span>
            <span className="market-cell ellipsis-text">
              {securityType === SECURITY_TYPE.Equity.id
                ? Formatter.divisionName(data, true)
                : get(
                    find(REGISTER_EXTENSION, { Exchange: exchange }),
                    "extension"
                  )}
            </span>
          </div>
          <span className="ellipsis-text">
            {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
          </span>
        </div>
      )
    }),
    createColumns("現在値", "currency-price-cell", (data: object) => (
      <PushSymbol
        apiSymbol={data}
        ticketKey={GetTicketKey(data)}
        renderer={(push: any, apiSymbol: any) => {
          const Price = !isEmpty(push)
            ? get(push, "Price")
            : get(apiSymbol, "Price")
          const PriceTime = !isEmpty(push)
            ? get(push, "PriceTime")
            : get(apiSymbol, "PriceTime")
          return (
            <div className="liquid-row">
              <div className="currency-price-value liquid-item">
                {Formatter.number(
                  isPushReceive ? Price : get(apiSymbol, "Price", null),
                  get(data, "NumberOfDecimals", 0)
                )}
              </div>
              <div className="time-col liquid-item">
                {Formatter.date(
                  isPushReceive ? PriceTime : get(apiSymbol, "PriceTime"),
                  "MM/DD HH:mm"
                )}
              </div>
            </div>
          )
        }}
      />
    )),
    createColumns("前日比 (%)", "changed-price-cell", (data: object) => (
      <PushSymbol
        apiSymbol={data}
        ticketKey={GetTicketKey(data)}
        renderIfChanged={{
          autoLoadingFlag,
        }}
        renderer={(push: any, apiSymbol: any, dataPush: any) => {
          const ChangedRatio = !isEmpty(push)
            ? get(push, "ChangedRatio")
            : get(apiSymbol, "ChangedRatio")
          const ChangedPrice = !isEmpty(push)
            ? get(push, "ChangedPrice")
            : get(apiSymbol, "ChangedPrice")
          const element = autoLoadingFlag ? dataPush : null
          return (
            <>
              <div
                {...element}
                className={ClassNames(
                  "change-price-value",
                  Formatter.upDown(
                    isPushReceive
                      ? ChangedPrice
                      : get(apiSymbol, "ChangedPrice", null)
                  )
                )}
              >
                {Formatter.number(
                  isPushReceive
                    ? ChangedPrice
                    : get(apiSymbol, "ChangedPrice", null),
                  2,
                  "floor",
                  true
                )}
              </div>
              <div className="change-ratio-value liquid-item">
                (
                <span
                  className={ClassNames(
                    Formatter.upDown(
                      isPushReceive
                        ? ChangedRatio
                        : get(apiSymbol, "ChangedRatio", null)
                    )
                  )}
                >
                  {Formatter.number(
                    isPushReceive
                      ? ChangedRatio
                      : get(apiSymbol, "ChangedRatio", null),
                    2,
                    "floor",
                    true
                  )}
                </span>
                <span className="unit">%</span>)
              </div>
            </>
          )
        }}
      />
    )),
    !isSp
      ? createColumns("始値", "ohlc-cell", (data: object) => (
          <PushSymbol
            apiSymbol={data}
            ticketKey={GetTicketKey(data)}
            renderer={(push: any, apiSymbol: any) => {
              const OpenPrice = !isEmpty(push)
                ? get(push, "OpenPrice")
                : get(apiSymbol, "OpenPrice")
              return Formatter.number(
                isPushReceive ? OpenPrice : get(apiSymbol, "OpenPrice", null),
                get(data, "NumberOfDecimals", 0)
              )
            }}
          />
        ))
      : null,
    !isSp
      ? createColumns("高値", "ohlc-cell", (data: object) => (
          <PushSymbol
            apiSymbol={data}
            ticketKey={GetTicketKey(data)}
            renderer={(push: any, apiSymbol: any) => {
              const HighPrice = !isEmpty(push)
                ? get(push, "HighPrice")
                : get(apiSymbol, "HighPrice")
              return Formatter.number(
                isPushReceive ? HighPrice : get(apiSymbol, "HighPrice", null),
                get(data, "NumberOfDecimals", 0)
              )
            }}
          />
        ))
      : null,
    !isSp
      ? createColumns("安値", "ohlc-cell", (data: object) => (
          <PushSymbol
            apiSymbol={data}
            ticketKey={GetTicketKey(data)}
            renderer={(push: any, apiSymbol: any, dataPush: any) => {
              const LowPrice = !isEmpty(push)
                ? get(push, "LowPrice")
                : get(apiSymbol, "LowPrice")
              return Formatter.number(
                isPushReceive ? LowPrice : get(apiSymbol, "LowPrice", null),
                get(data, "NumberOfDecimals", 0)
              )
            }}
          />
        ))
      : null,
    !isSp
      ? createColumns("出来高", "volume-cell", (data: object) => (
          <PushSymbol
            apiSymbol={data}
            ticketKey={GetTicketKey(data)}
            renderer={(push: any, apiSymbol: any, dataPush: any) => {
              const TradVolume = !isEmpty(push)
                ? get(push, "TradVolume")
                : get(apiSymbol, "TradVolume")
              return Formatter.number(
                isPushReceive ? TradVolume : get(apiSymbol, "TradVolume", null)
              )
            }}
          />
        ))
      : null,
    props.registerWindow || isSp
      ? null
      : createColumns("", "delete-cell", (data: object, index: number) => (
          <DeleteColumn
            fn={() =>
              store.dispatch(
                removeRegisterSymbolSheet(
                  index,
                  props.registerSymbol.symbolSheet
                )
              )
            }
            show={showId === index}
            setShow={(isShow: boolean) => setShowId(isShow ? index : null)}
          />
        )),
  ])
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    data => {
      return {
        id: data.SheetNo,
        name: data.SheetName,
      }
    }
  )
  return (
    <Panel
      title=""
      className="panel-four main"
      filter={
        <div className="control-row filter-control-row">
          <div className="filter-control-item">
            <div className="label-filter-control">表示リスト選択</div>
          </div>
          <div className="row-filter">
            <BaseSelect
              option={sheetList}
              value={props.registerSymbol.symbolSheet.SheetNo}
              onChange={(num: number) => {
                store.dispatch(changeRegisterSheet(String(num)))
              }}
            />
          </div>
        </div>
      }
    >
      <div className="registered-issues-edit-col">
        <SeparateTable
          className="table-list-view"
          emptyText="「登録内容変更」画面から銘柄を登録してください。"
          list={tableList}
          data={props.tableData}
          setData={props.setTableData}
          active={currentPosition}
          scrollable={
            get(props.registerSymbol.symbolSheet.SymbolList, "length", 0) >
              16 && !isSp
          }
          draggable={true}
          setDropFlag={setDropFlag}
          onClick={(data: object, i: number) => {
            requestSymbol(data, () =>
              props.setSymbol({
                type: "SET_SYMBOL_DETAIL",
                symbol: {
                  Symbol: get(data, "Symbol", null),
                  Exchange: get(data, "Exchange", null),
                  SecurityType: get(data, "SecurityType", null),
                },
              })
            )
            changePosition(i)
          }}
        />
      </div>
    </Panel>
  )
}

export const SignValue: React.FC<RegisterPropsType> = props => {
  const [currentPosition, changePosition] = useState<number>(0)
  const [showId, setShowId] = useState<number>(null)
  const [screenSize, setScreenSize] = useState(window.outerWidth)
  const [dropFlag, setDropFlag] = useState(false)

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenSize(window.innerWidth)
    })
  })

  useEffect(() => {
    setTableData(
      props.registerSymbol.symbolSheet.SymbolList,
      props.setTableData
    )
    setDropFlag(false)
  }, [props.registerSymbol.symbolSheet.SymbolList])

  useEffect(() => {
    if (dropFlag) {
      store.dispatch(
        editRegisterSymbolSheet({
          SheetNo: props.registerSymbol.symbolSheet.SheetNo,
          SheetName: props.registerSymbol.symbolSheet.SheetName,
          SymbolList: props.tableData,
        })
      )
    }
  }, [dropFlag])

  const tableList = [
    // createColumns("", "sort-cell", () => (
    //   <i className="material-icons">drag_handle</i>
    // )),
    createColumns("国", "country-cell", (data: object) => (
      <i
        className={`icon-solid icon-${get(
          find(EQUITY_SECURITY_LIST, {
            SecurityType: get(data, "SecurityType"),
          }),
          "icon"
        )}`}
      />
    )),
    createColumns("銘柄名", "symbol-name-cell", (data: object) => {
      const securityType = get(data, "SecurityType")
      const exchange = get(data, "Exchange")
      return (
        <div>
          <div className="code-market-group">
            <span className="code-cell ellipsis-text">
              {Formatter.symbol(data)}
            </span>
            <span className="market-cell ellipsis-text">
              {securityType === SECURITY_TYPE.Equity.id
                ? Formatter.divisionName(data, true)
                : get(
                    find(REGISTER_EXTENSION, { Exchange: exchange }),
                    "extension"
                  )}
            </span>
          </div>
          <span className="ellipsis-text">
            {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
          </span>
        </div>
      )
    }),
    createColumns("現在値", "currency-price-cell", (data: object) => (
      <div className="liquid-row">
        <div className="currency-price-value liquid-item">
          {Formatter.number(
            get(data, "Price", null),
            get(data, "NumberOfDecimals", 0)
          )}
        </div>
        <div className="time-col liquid-item">
          {Formatter.date(get(data, "PriceTime"), "MM/DD HH:mm")}
        </div>
      </div>
    )),
    createColumns("前日比 (%)", "changed-price-cell", (data: object) => {
      return (
        <>
          <div
            className={ClassNames(
              "change-price-value",
              Formatter.upDown(get(data, "ChangedPrice", null))
            )}
          >
            {Formatter.number(
              get(data, "ChangedPrice", null),
              2,
              "floor",
              true
            )}
          </div>
          <div className="change-ratio-value liquid-item">
            (
            <span
              className={ClassNames(
                Formatter.upDown(get(data, "ChangedRatio", null))
              )}
            >
              {Formatter.number(
                get(data, "ChangedRatio", null),
                2,
                "floor",
                true
              )}
            </span>
            <span className="unit">%</span>)
          </div>
        </>
      )
    }),
    createColumns("売数量", "ohlc-cell", (data: object) =>
      Formatter.number(get(data, "BidVolume", null))
    ),
    createColumns("売気配", "ohlc-cell", (data: object) =>
      Formatter.number(get(data, "Bid", null), get(data, "NumberOfDecimals", 0))
    ),
    createColumns("買気配", "ohlc-cell", (data: object) =>
      Formatter.number(get(data, "Ask", null), get(data, "NumberOfDecimals", 0))
    ),
    createColumns("買数量", "ohlc-cell", (data: object) =>
      Formatter.number(get(data, "AskVolume", null))
    ),
    createColumns("", "delete-cell", (data: object, index: number) => (
      <DeleteColumn
        fn={() =>
          store.dispatch(
            removeRegisterSymbolSheet(index, props.registerSymbol.symbolSheet)
          )
        }
        show={showId === index}
        setShow={(isShow: boolean) => setShowId(isShow ? index : null)}
      />
    )),
  ]
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    data => {
      return {
        id: data.SheetNo,
        name: data.SheetName,
      }
    }
  )

  return (
    <Panel
      title=""
      className="panel-sign"
      filter={
        <div className="control-row filter-control-row">
          <div className="filter-control-item">
            <div className="label-filter-control">表示リスト選択</div>
          </div>
          <div className="row-filter">
            <BaseSelect
              option={sheetList}
              value={props.registerSymbol.symbolSheet.SheetNo}
              onChange={(num: number) => {
                store.dispatch(changeRegisterSheet(String(num)))
              }}
            />
          </div>
        </div>
      }
    >
      <div className="registered-issues-edit-col">
        <SeparateTable
          className="table-list-view"
          emptyText="「登録内容変更」画面から銘柄を登録してください。"
          list={tableList}
          data={props.tableData}
          setData={props.setTableData}
          active={currentPosition}
          scrollable={props.registerSymbol.symbolSheet.SymbolList.length > 16}
          draggable={true}
          setDropFlag={setDropFlag}
          onClick={(data: object, i: number) => {
            props.setSymbol({
              type: "SET_SYMBOL_DETAIL",
              symbol: {
                Symbol: get(data, "Symbol", null),
                Exchange: get(data, "Exchange", null),
                SecurityType: get(data, "SecurityType", null),
              },
            })
            changePosition(i)
          }}
        />
      </div>
    </Panel>
  )
}

export const Portfolio: React.FC<RegisterPropsType> = props => {
  const [currentPosition, changePosition] = useState<number>(0)
  const [showId, setShowId] = useState<number>(null)
  const [dropFlag, setDropFlag] = useState(false)

  useEffect(() => {
    setTableData(
      props.registerSymbol.symbolSheet.SymbolList,
      props.setTableData
    )
    setDropFlag(false)
  }, [props.registerSymbol.symbolSheet.SymbolList])

  useEffect(() => {
    if (dropFlag) {
      store.dispatch(
        editRegisterSymbolSheet({
          SheetNo: props.registerSymbol.symbolSheet.SheetNo,
          SheetName: props.registerSymbol.symbolSheet.SheetName,
          SymbolList: props.tableData,
        })
      )
    }
  }, [dropFlag])

  const tableColumn = [
    [
      // createColumns(
      //   "",
      //   "sort-cell",
      //   () => <i className="material-icons">drag_handle</i>,
      //   false,
      //   false,
      //   2
      // ),
      createColumns(
        "国",
        "country-cell",
        (data: object) => (
          <i
            className={`icon-solid icon-${get(
              find(EQUITY_SECURITY_LIST, {
                SecurityType: get(data, "SecurityType"),
              }),
              "icon"
            )}`}
          />
        ),
        false,
        false,
        2
      ),
      createColumns(
        "銘柄名",
        "symbol-name-cell",
        (data: object) => {
          const securityType = get(data, "SecurityType")
          const exchange = get(data, "Exchange")
          return (
            <div>
              <div className="code-market-group">
                <span className="code-cell ellipsis-text">
                  {Formatter.symbol(data)}
                </span>
                <span className="market-cell ellipsis-text">
                  {securityType === SECURITY_TYPE.Equity.id
                    ? Formatter.divisionName(data, true)
                    : get(
                        find(REGISTER_EXTENSION, { Exchange: exchange }),
                        "extension"
                      )}
                </span>
              </div>
              <span className="ellipsis-text">
                {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
              </span>
            </div>
          )
        },
        false,
        false,
        2
      ),
      createColumns(
        "株数",
        "amount-stock-cell",
        (data: object) => (
          <span>{Formatter.number(get(data, "LeavesQty"))}</span>
        ),
        false,
        false,
        2
      ),
      createColumns(
        "現在値",
        "value-cell changed-price-cell",
        (data: object) => (
          <div className="value-group">
            <div className="value-text">
              <span>
                {Formatter.number(
                  get(data, "Price", null),
                  get(data, "NumberOfDecimals", 0)
                )}
              </span>
              <span className="time-col unit">
                {Formatter.date(get(data, "PriceTime"), "HH:mm")}
              </span>
            </div>
            <div className="changed-price-text">
              <span
                className={ClassNames(
                  "change-price-value",
                  Formatter.upDown(get(data, "ChangedPrice", null))
                )}
              >
                {Formatter.number(
                  get(data, "ChangedPrice", null),
                  2,
                  "floor",
                  true
                )}
              </span>
              <span className="change-ratio-value liquid-item">
                (
                <span
                  className={ClassNames(
                    Formatter.upDown(get(data, "ChangedRatio", null))
                  )}
                >
                  {Formatter.number(
                    get(data, "ChangedRatio", null),
                    2,
                    "floor",
                    true
                  )}
                </span>
                <span className="unit">%</span>)
              </span>
            </div>
          </div>
        )
      ),
      createColumns("実勢為替", "value-cell", (data: object) => (
        <span>
          {Formatter.number(
            get(data, "NowExRate", null),
            get(data, "SecurityType") === 1
              ? 0
              : get(data, "SecurityType") === 100
              ? 2
              : 4
          )}
        </span>
      )),
      createColumns("時価評価", "value-cell", (data: object) => (
        <span>
          {Formatter.number(
            calcContractPrice(
              get(data, "Price", null),
              get(data, "LeavesQty"),
              get(data, "NowExRate", null)
            ),
            get(data, "NumberOfDecimals", 0)
          )}
        </span>
      )),
      createColumns(
        "評価損益",
        "value-cell",
        (data: object) => (
          <span>
            {Formatter.number(
              calcEvaluateProfit(
                get(data, "Price", null),
                get(data, "LeavesQty"),
                get(data, "NowExRate", null),
                get(data, "AvgPx", null),
                get(data, "ExRate", null)
              ),
              get(data, "NumberOfDecimals", 0)
            )}
          </span>
        ),
        false,
        false,
        2
      ),
      // createColumns(
      //   "更新",
      //   "date-time-cell",
      //   (data: object) => (
      //     <>
      //       <div>{Formatter.date(get(data, "PriceTime"), "MM/DD")}</div>
      //       <div>{Formatter.date(get(data, "PriceTime"), "HH:mm")}</div>
      //     </>
      //   ),
      //   false,
      //   false,
      //   2
      // ),
      createColumns(
        "",
        "delete-cell",
        (data: object, index: number) => (
          <DeleteColumn
            fn={() =>
              store.dispatch(
                removeRegisterSymbolSheet(
                  index,
                  props.registerSymbol.symbolSheet
                )
              )
            }
            show={showId === index}
            setShow={(isShow: boolean) => setShowId(isShow ? index : null)}
          />
        ),
        false,
        false,
        2
      ),
    ],
    [
      createColumns(
        "購入単価",
        "value-cell changed-price-cell ",
        (data: object) => {
          const isAvgPx = !isNil(get(data, "AvgPx", null))
          return (
            <div className="value-group">
              <div
                className={ClassNames("value-text avg-px", {
                  "empty-data": !isAvgPx,
                })}
              >
                <span>
                  {Formatter.number(
                    get(data, "AvgPx", null),
                    get(data, "NumberOfDecimals", 0)
                  )}
                </span>
                <span className="unit" />
              </div>
              <div className="stretch-cell" />
            </div>
          )
        }
      ),
      createColumns("約定為替", "value-cell", (data: object) =>
        Formatter.number(
          get(data, "ExRate", null),
          get(data, "SecurityType") === 1
            ? 0
            : get(data, "SecurityType") === 100
            ? 2
            : 4
        )
      ),
      createColumns("約定代金", "value-cell", (data: object) => {
        return Formatter.number(
          calcContractPrice(
            get(data, "AvgPx", null),
            get(data, "LeavesQty"),
            get(data, "ExRate", null)
          ),
          get(data, "NumberOfDecimals", 0)
        )
      }),
    ],
  ]
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    data => {
      return {
        id: data.SheetNo,
        name: data.SheetName,
      }
    }
  )

  const profileHeader = () => {
    // ヘッダーにリストの合計を表示
    let sumExecutionValue: number = null
    let tempExecutionValue: number = null
    let sumRealValue: number = null
    let tempRealValue: number = null
    let sumProfitLoss: number = null
    map(props.registerSymbol.symbolSheet.SymbolList, list => {
      tempExecutionValue = get(list, "AvgPx", 0) * get(list, "LeavesQty", 0)
      tempRealValue = get(list, "Price", 0) * get(list, "LeavesQty", 0)
      sumExecutionValue += tempExecutionValue
      sumRealValue += tempRealValue
      sumProfitLoss += tempRealValue - tempExecutionValue
    })
    const sign = (num: number) => {
      return num > 0 ? "+" + num.toLocaleString() : num.toLocaleString()
    }
    return (
      <>
        <table className="table table-summary-value">
          <tr>
            <th>取得価格合計</th>
            <td>
              {isNull(sumExecutionValue)
                ? "-"
                : sumExecutionValue.toLocaleString()}
            </td>
            <th>時価評価合計</th>
            <td className={ClassNames(Formatter.upDown(sumRealValue))}>
              {isNull(sumRealValue) ? "-" : sign(sumRealValue)}
            </td>
            <th>評価損益合計</th>
            <td className={ClassNames(Formatter.upDown(sumProfitLoss))}>
              {isNull(sumProfitLoss) ? "-" : sign(sumProfitLoss)}
            </td>
          </tr>
        </table>
      </>
    )
  }

  return (
    <Panel
      title=""
      className="panel-portfolio"
      filter={
        <div className="control-row filter-control-row">
          <div className="filter-control-item">
            <div className="label-filter-control">表示リスト選択</div>
          </div>
          <div className="row-filter">
            <BaseSelect
              option={sheetList}
              value={props.registerSymbol.symbolSheet.SheetNo}
              onChange={(num: number) => {
                store.dispatch(changeRegisterSheet(String(num)))
              }}
            />
          </div>
        </div>
      }
    >
      {profileHeader()}
      <div className="registered-issues-edit-col">
        <MultipleLineTable
          className="table-list-view"
          list={tableColumn}
          data={props.tableData}
          setData={props.setTableData}
          draggable={true}
          setDropFlag={setDropFlag}
          emptyText="「登録内容変更」画面から銘柄を登録してください。"
          scrollable={props.registerSymbol.symbolSheet.SymbolList.length > 14}
          // active={currentPosition}
          // onClick={(data: object, i: number) => {
          //   props.setSymbol({
          //     type: "SET_SYMBOL_DETAIL",
          //     symbol: {
          //       Symbol: get(data, "Symbol", null),
          //       Exchange: get(data, "Exchange", null),
          //       SecurityType: get(data, "SecurityType", null),
          //     },
          //   })
          //   console.log("i：", i)
          //   changePosition(i)
          // }}
        />
      </div>
    </Panel>
  )
}

type RegisterSymbolType = {
  id: string
  AvgPx: number | null
  ExRate: number | null
  LeavesQty: number | null
}

type RegisterSymbolStateType = {
  registerSymbolList?: Array<RegisterSymbolType>
}

type RegisterSymbolActionType = {
  type: "REGISTER_SET_ALL" | "REGISTER_EDIT_LIST"
  list?: Array<RegisterSymbolType>
  editItem?: { [t: string]: string }
}

const initialState: RegisterSymbolStateType = {
  registerSymbolList: [],
}

const registerReducer = (
  state: RegisterSymbolStateType,
  action: RegisterSymbolActionType
) => {
  switch (action.type) {
    case "REGISTER_SET_ALL":
      return { registerSymbolList: action.list }
    case "REGISTER_EDIT_LIST":
      const cloneList = clone(state.registerSymbolList)
      const newList = cloneList.map(li => {
        if (li.id === get(action.editItem, "id")) {
          return merge(li, action.editItem)
        } else {
          return li
        }
      })

      return { registerSymbolList: newList }
    default:
      return state
  }
}
type EditRegisterSymbolListProps = (
  editList: Array<RegisterSymbolType>,
  currentList: SymbolSheetType
) => void

const editRegisterSymbolList: EditRegisterSymbolListProps = (
  editList,
  currentList
) => {
  const sheetList = clone(currentList.SymbolList)
  const editSheetList: Array<APIResponse.Res> = sheetList.map(
    (data: APIResponse.Res, i: number) => {
      return merge(data, editList[i])
    }
  )
  currentList["SymbolList"] = editSheetList
  store.dispatch(editRegisterSymbolSheet(currentList))
}

type SearchColumnContentType = React.FC<{
  data: APIResponse.Res
  index: number
  execute: Function
}>
const SearchColumnContent: SearchColumnContentType = props => {
  const [selectedCountry, changeCountry] = useState<undefined | string>("null")
  const [emptyRowSelect, setEmptyRowSelect] = useState<string>("0")
  const isRegisterRow = get(props.data, "Symbol", null)
  const countryList = DETAIL_SEARCH_CONDITIONS.MARKETS.map((li, i) => {
    return {
      id: String(i),
      name: li.country,
      icon: li.icon,
      securityType: li.securityType,
    }
  })

  useEffect(() => {
    const countryKey = get(
      find(countryList, {
        securityType: get(props.data, "SecurityType"),
      }),
      "id"
    )
    countryKey ? changeCountry(countryKey) : changeCountry(emptyRowSelect)
  }, [props.data])

  useEffect(() => {
    if (isEmpty(props.data)) {
      changeCountry(emptyRowSelect)
    }
  }, [emptyRowSelect])
  return (
    <div className="register-cell">
      <div className="row-filter">
        <BaseSelect
          option={countryList}
          value={selectedCountry || emptyRowSelect}
          onChange={(id: string) => {
            changeCountry(id)
            if (isEmpty(props.data)) {
              setEmptyRowSelect(id)
            }
          }}
        />
      </div>
      <SearchDetail
        key={uuid()}
        className="search-bar"
        inputClassName="text-field-input numeric-input"
        initialState={{ searchValue: Formatter.symbol(props.data) }}
        executeFunction={(data: APIResponse.Res) =>
          props.execute(data, props.index)
        }
        placeholder={!isRegisterRow ? "銘柄コード/銘柄名" : ""}
        hasCountryBtn={true}
        forceActive={true}
        isDirect={true}
        selectCountry={selectedCountry}
        noMemory={true}
        inputId="search-register-header"
      />
    </div>
  )
}

export const Register: React.FC<RegisterPropsType> = props => {
  const [registerState, registerAction] = useReducer(
    registerReducer,
    initialState
  )
  // const [isSelect, changeSelect] = useState<boolean>(false)
  const [currentSheetName, changeCurrentSheetName] = useState<string>(
    props.registerSymbol.symbolSheet.SheetName
  )
  const [dropFlag, setDropFlag] = useState(false)

  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const [showId, setShowId] = useState<number>(null)

  useEffect(() => {
    changeCurrentSheetName(props.registerSymbol.symbolSheet.SheetName)
  }, [props.registerSymbol.symbolSheet.SheetNo])

  useEffect(() => {
    const registerSymbolList: Array<RegisterSymbolType> = map(
      props.registerSymbol.symbolSheet.SymbolList,
      data => {
        return {
          id: uuid(),
          AvgPx: get(data, "AvgPx", ""),
          ExRate: get(data, "SecurityType") === 1 ? 1 : get(data, "ExRate", ""),
          LeavesQty: get(data, "LeavesQty", ""),
        }
      }
    )
    registerAction({ type: "REGISTER_SET_ALL", list: registerSymbolList })
  }, [props.registerSymbol.symbolSheet.SymbolList])

  const executeSearchFunction = (data: APIResponse.Res, index: number) => {
    const symbolSheet = clone(props.registerSymbol.symbolSheet)
    if (props.registerSymbol.symbolSheet.SymbolList.length - 1 < index) {
      symbolSheet["SymbolList"] = concat(symbolSheet.SymbolList, data)
    } else {
      symbolSheet["SymbolList"] = symbolSheet.SymbolList.map(
        (row: APIResponse.Res, i: number) =>
          index === i
            ? merge(data, registerState.registerSymbolList[index])
            : row
      )
    }
    store.dispatch(editRegisterSymbolSheet(symbolSheet))
  }

  useEffect(() => {
    setTableData(
      props.registerSymbol.symbolSheet.SymbolList.length < 50
        ? concat(props.registerSymbol.symbolSheet.SymbolList, {})
        : props.registerSymbol.symbolSheet.SymbolList,
      props.setTableData
    )
    setDropFlag(false)
  }, [props.registerSymbol.symbolSheet.SymbolList])

  useEffect(() => {
    if (dropFlag) {
      store.dispatch(
        editRegisterSymbolSheet({
          SheetNo: props.registerSymbol.symbolSheet.SheetNo,
          SheetName: props.registerSymbol.symbolSheet.SheetName,
          SymbolList: get(props.tableData[props.tableData.length - 1], "Symbol")
            ? props.tableData
            : initial(props.tableData),
        })
      )
    }
  }, [dropFlag])

  const tableList = compact([
    createColumns("", "ranking-cell", (d: object, i: number) => i + 1),
    createColumns("", "search-register-cell", (data: object, index: number) => {
      return (
        <SearchColumnContent
          data={data}
          index={index}
          execute={executeSearchFunction}
        />
      )
    }),
    createColumns("銘柄名", "symbol-name-cell", (data: object) => (
      <span className="ellipsis-text">
        {get(data, "SymbolNameS", "") || get(data, "SymbolName", "")}
      </span>
    )),
    !isSp
      ? createColumns("株数", "amount-cell", (data: object, index: number) => (
          <ChartInputNumeric
            defaultValue={
              get(registerState.registerSymbolList[index], "LeavesQty") || ""
            }
            step={1}
            // step={get(data, "TradingUnit")}
            min={1}
            max={999999}
            decimalDigits={0}
            setValue={(num: number) => {
              registerAction({
                type: "REGISTER_EDIT_LIST",
                editItem: {
                  id: get(registerState.registerSymbolList[index], "id"),
                  LeavesQty: String(num),
                },
              })
            }}
            manualOnly={true}
          />
        ))
      : null,
    !isSp
      ? createColumns(
          "購入単価",
          "amount-cell",
          (data: object, index: number) => (
            <ChartInputNumeric
              defaultValue={
                get(registerState.registerSymbolList[index], "AvgPx") || ""
              }
              step={1}
              min={0}
              max={999999}
              decimalDigits={get(data, "NumberOfDecimals")}
              setValue={(num: number) => {
                // let value = num
                // if (get(data, "CalclatedPrice") && num === 1) {
                //   value = get(data, "CalclatedPrice")
                // }
                registerAction({
                  type: "REGISTER_EDIT_LIST",
                  editItem: {
                    id: get(registerState.registerSymbolList[index], "id"),
                    AvgPx: String(num),
                  },
                })
              }}
              manualOnly={true}
            />
          )
        )
      : null,
    !isSp
      ? createColumns(
          "約定為替",
          "amount-cell",
          (data: object, index: number) => (
            <ChartInputNumeric
              defaultValue={
                get(data, "SecurityType") === 1
                  ? 1
                  : get(registerState.registerSymbolList[index], "ExRate")
                  ? get(registerState.registerSymbolList[index], "ExRate")
                  : ""
              }
              step={1}
              min={
                get(data, "SecurityType") === SECURITY_TYPE.Equity.id
                  ? 1
                  : get(data, "SecurityType") === SECURITY_TYPE.US_Equity.id
                  ? 0.01
                  : 0.0001
              }
              max={999999}
              decimalDigits={
                get(data, "SecurityType") === SECURITY_TYPE.Equity.id
                  ? 0
                  : get(data, "SecurityType") === SECURITY_TYPE.US_Equity.id
                  ? 2
                  : 4
              }
              setValue={(num: number) => {
                let value = num
                if (get(data, "SecurityType") === 1) {
                  value = 1
                }
                registerAction({
                  type: "REGISTER_EDIT_LIST",
                  editItem: {
                    id: get(registerState.registerSymbolList[index], "id"),
                    ExRate: String(value),
                  },
                })
              }}
              disable={get(data, "SecurityType") === 1}
              manualOnly={true}
            />
          )
        )
      : null,
    createColumns(
      "",
      "delete-cell",
      (data: object, index: number) =>
        !isEmpty(data) && (
          <DeleteColumn
            fn={() =>
              store.dispatch(
                removeRegisterSymbolSheet(
                  index,
                  props.registerSymbol.symbolSheet
                )
              )
            }
            show={showId === index}
            setShow={(isShow: boolean) => setShowId(isShow ? index : null)}
          />
        )
    ),
  ])
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    data => {
      return {
        id: data.SheetNo,
        name: data.SheetName,
      }
    }
  )
  return (
    <Panel
      title=""
      className={ClassNames("panel-register", {
        sp: isSp,
      })}
      filter={
        <div className="control-row filter-control-row">
          <div className="list-select">
            <div className="filter-control-item">
              <div className="label-filter-control">表示リスト選択</div>
            </div>
            <div className="row-filter">
              <BaseSelect
                option={sheetList}
                value={props.registerSymbol.symbolSheet.SheetNo}
                onChange={(num: number) => {
                  store.dispatch(changeRegisterSheet(String(num)))
                }}
              />
            </div>
          </div>
          {!isSp ? (
            <div className="sheet-name-change-row">
              <div className="filter-control-item">
                <div className="label-filter-control">リスト名</div>
                <div className="text-field text-field-outlined">
                  <input
                    type="text"
                    className="text-field-input"
                    maxLength={16}
                    placeholder=""
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      changeCurrentSheetName(e.target.value)
                    }
                    value={currentSheetName}
                  />
                </div>
              </div>
              <div className="filter-control-item">
                <div
                  className="btn btn-primary btn-shaped"
                  onClick={() =>
                    store.dispatch(
                      changeRegisterSheetName(
                        currentSheetName,
                        props.registerSymbol.symbolSheet
                      )
                    )
                  }
                >
                  リスト名を変更する
                </div>
                <div
                  className="btn btn-primary btn-shaped"
                  onClick={() => {
                    editRegisterSymbolList(
                      registerState.registerSymbolList,
                      props.registerSymbol.symbolSheet
                    )
                    store.dispatch(
                      setToastData({
                        bodyMessage: "登録しました",
                      })
                    )
                  }}
                >
                  登録
                </div>
                <LumpRegisterModal data={props.registerSymbol.symbolSheet} />
                <div>
                  <SymbolRegisterListBtns />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      }
    >
      <div className="registered-issues-edit-col">
        <SeparateTable
          className="table-striped"
          list={tableList}
          data={props.tableData}
          setData={props.setTableData}
          draggable={true}
          setDropFlag={setDropFlag}
          scrollable={props.registerSymbol.symbolSheet.SymbolList.length > 19}
        />
      </div>
    </Panel>
  )
}

const DownloadListBtn = (props: { onHide: Function }) => {
  const { onHide } = props
  const _export = async () => {
    const res = await APIs.Tool.GetRealSymbolSheetList()
    const sheetList = get(res, "SheetList")
    const data = map(sheetList, items => {
      const SheetName = get(items, "SheetName")
      const SheetNo = get(items, "SheetNo")
      const sheetContents = get(items, "SheetContents")
      if (isEmpty(sheetContents)) return [{ SheetName, SheetNo }]
      return map(sheetContents, content =>
        merge(content, { SheetName, SheetNo })
      )
    })
    let _data: Array<object> = []
    forEach(data, items => _data.push(...items))
    outputCSV(_data, `登録銘柄リスト_${dayjs().format("YYYY/MM/DD")}.csv`)
    onHide()
  }
  return (
    //DEMO版なので押させない
    <div className="btn btn-primary btn-shaped" onClick={() => {}}>
      {/*<div className="btn btn-primary btn-shaped" onClick={() => _export()}>*/}
      登録銘柄リストDL
    </div>
  )
}
const UploadListBtn = (props: { onHide: Function }) => {
  const { onHide } = props
  return (
    <div className="btn btn-primary btn-shaped">
      <label htmlFor="inputFile">登録銘柄リスト読込</label>
      {/*DEMO版なので押させない*/}
      {/*<input*/}
      {/*  id="inputFile"*/}
      {/*  type="file"*/}
      {/*  accept=".csv"*/}
      {/*  onChange={e => {*/}
      {/*    const file = e.target.files[0]*/}
      {/*    const reader = new FileReader()*/}
      {/*    reader.readAsText(file)*/}
      {/*    reader.onload = async event => {*/}
      {/*      const res = get(event.target, "result") as string*/}
      {/*      const csv = res.split("\n")*/}
      {/*      const header = split(head(csv), ",")*/}
      {/*      const body = tail(csv)*/}
      {/*      const mergedBody = map(body, (str: string) => {*/}
      {/*        const _header = map(header, str => str.replace(/\s+/g, ""))*/}
      {/*        return zipObject(_header, split(str, ","))*/}
      {/*      })*/}
      {/*      const _data = map(*/}
      {/*        groupBy(mergedBody, "SheetName"),*/}
      {/*        (items, key) => {*/}
      {/*          const SheetNo = Object.keys(groupBy(items, "SheetNo"))*/}
      {/*          const SymbolList = map(items, item => {*/}
      {/*            return pick(item, [*/}
      {/*              "AvgPx",*/}
      {/*              "Code",*/}
      {/*              "ExRate",*/}
      {/*              "Exchange",*/}
      {/*              "LeavesQty",*/}
      {/*              "Memo",*/}
      {/*              "SecurityType",*/}
      {/*              "SeqNum",*/}
      {/*              "Symbol",*/}
      {/*            ])*/}
      {/*          })*/}
      {/*          const SheetName = key.length > 40 ? key.slice(0, 40) : key*/}
      {/*          return {*/}
      {/*            SheetName,*/}
      {/*            SheetNo: get(SheetNo, 0),*/}
      {/*            SymbolList: !(*/}
      {/*              SymbolList.length >= 1 &&*/}
      {/*              get(SymbolList, [0, "Exchange"]) &&*/}
      {/*              get(SymbolList, [0, "Symbol"]) &&*/}
      {/*              get(SymbolList, [0, "SecurityType"])*/}
      {/*            )*/}
      {/*              ? []*/}
      {/*              : SymbolList.length > 50*/}
      {/*              ? take(SymbolList, 50)*/}
      {/*              : SymbolList,*/}
      {/*          }*/}
      {/*        }*/}
      {/*      )*/}
      {/*      let errorFlag = false*/}
      {/*      forEach(*/}
      {/*        _data.length > 40 ? take(_data, 40) : _data,*/}
      {/*        async param => {*/}
      {/*          try {*/}
      {/*            if (*/}
      {/*              !get(param, "SheetName") ||*/}
      {/*              !get(param, "SheetNo") ||*/}
      {/*              !get(param, "SymbolList")*/}
      {/*            )*/}
      {/*              throw "e"*/}

      {/*            await APIs.Tool.EditSymbolSheet(param)*/}
      {/*            // console.log(*/}
      {/*            //   param,*/}
      {/*            //   !!(*/}
      {/*            //     get(param, "SymbolList").length >= 1 &&*/}
      {/*            //     get(param, ["SymbolList", 0, "Exchange"]) &&*/}
      {/*            //     get(param, ["SymbolList", 0, "Symbol"]) &&*/}
      {/*            //     get(param, ["SymbolList", 0, "SecurityType"])*/}
      {/*            //   )*/}
      {/*            // )*/}
      {/*          } catch {*/}
      {/*            console.warn(*/}
      {/*              `${get(param, "SheetNo")}: ${get(*/}
      {/*                param,*/}
      {/*                "SheetName"*/}
      {/*              )}を登録できませんでした。`*/}
      {/*            )*/}
      {/*            errorFlag = true*/}
      {/*          }*/}
      {/*        }*/}
      {/*      )*/}
      {/*      // EditSymbolSheetを投げて、変更されてからSymbolSheetを投げる必要があるため、時間を置く必要がある。*/}
      {/*      // TODO　時間は見直しが必要。*/}
      {/*      await setTimeout(() => {*/}
      {/*        store.dispatch(initRegisterLoad())*/}
      {/*        store.dispatch(*/}
      {/*          setToastData({*/}
      {/*            bodyMessage: errorFlag*/}
      {/*              ? "読み込みに失敗したシートがあります。"*/}
      {/*              : "読み込みに成功しました。",*/}
      {/*          })*/}
      {/*        )*/}
      {/*      }, 1000)*/}
      {/*      onHide()*/}
      {/*    }*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  )
}

const SymbolRegisterListBtns = () => {
  const [visible, setVisible] = useState(false)
  return (
    <div className="symbol-register-list-btns-group">
      <div
        className="btn btn-icon btn-primary icon-ripple"
        onClick={() => setVisible(!visible)}
        title="ファイル　インポート/エクスポート"
      >
        {/* <span> */}
        <i className="material-icons">import_export</i>
        {/* </span> */}
      </div>
      {visible && (
        <>
          <div className="close-trigger" onClick={() => setVisible(false)} />
          <div
            className={ClassNames("symbol-register-list-items", {
              visible,
            })}
          >
            <div className="symbol-register-list-btn">
              <DownloadListBtn onHide={() => setVisible(false)} />
            </div>
            <div className="symbol-register-list-btn">
              <UploadListBtn onHide={() => setVisible(false)} />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
